import { ReactNode, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isClientLoggedIn } from "utils/clientSession";

type ClientProtectedRouteProps = {
  children: ReactNode;
};

export default function ClientProtectedRoute({ children }: ClientProtectedRouteProps) {
  const location = useLocation();

  if (!isClientLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
